<template>
  <main>
    <div class="workspace workspace-grid">
      <div>
        <div v-if="getBanner1() || getBanner2() || getBanner3() || getBanner4()">
          <div class="static-element-header light"></div>
          <div class="static-element">
            <a v-if="getBanner1()" :href="getBanner1().link" target="_blank"><img :src="getBanner1().img" width="470" style="margin-right: 30px"></a>
            <a v-if="getBanner2()" :href="getBanner2().link" target="_blank"><img :src="getBanner2().img" width="470"></a>
            <a v-if="getBanner3()" :href="getBanner3().link" target="_blank"><img :src="getBanner3().img" width="470" style="margin-right: 30px"></a>
            <a v-if="getBanner4()" :href="getBanner4().link" target="_blank"><img :src="getBanner4().img" width="470"></a>
          </div>
        </div>

        <div v-if="!infopanelIsHidden">
          
          <div class="static-element-header light">
            Introduction
            <CancelButton
              class="cancButton"
              @click="infopanelIsHidden = !infopanelIsHidden"
            />
          </div>
          <div class="static-element">
            LoopGrafter is intended to provide guidance on transplanting loops
            between two structurally related proteins, (<span
              style="color: var(--scaffold-light)"
              >scaffold</span
            >
            or source, and
            <span style="color: var(--insert)">insert</span> or target),
            while assessing their dynamic properties. For the tool to work as
            intended, we recommend performing the grafting on proteins that
            differ in no more than 8 Angstroms RMSD and than 20% of sequence
            length.
          </div>
        </div>

        <div class="static-element-header grad">Input Structures</div>
        <div class="static-element">
          <LoopsProteinSelection />
        </div>

        <div class="static-element-header grad">Job Information</div>
        <div class="static-element">
          <JobInformation />
        </div>
      </div>

      <RightInfoPanel />
    </div>

    <div class="workspace">
      <!-- <div class="static-element-header light">Disclamer</div> -->
      <div class="static-element footer-block">
        <b>Disclaimer</b>: The responsibility of the LoopGrafter authors
        is limited to applying best efforts in providing a useful service. The
        authors can not be held liable in any way for the service provided here.
        <br />
        <b>Keywords</b>: protein engineering, protein loop grafting,
        multiple-point mutants, protein dynamics, protein stability
        <br />
        <router-link :to="{ name: 'terms' }"> Terms Of Use</router-link>
        |
        <router-link :to="{ name: 'privacy' }">Privacy</router-link>
      </div>
    </div>
  </main>
</template>

<script>
import LoopsProteinSelection from "../components/LoopsProteinSelection";
import JobInformation from "../components/JobInformation";
import RightInfoPanel from "../components/RightInfoPanel";
import LabelButton from "../components/PanelButtons/TextLabelButton";
import CancelButton from "../components/PanelButtons/CancelButton";
import { mapActions } from "vuex";

export default {
  components: {
    LoopsProteinSelection,
    JobInformation,
    LabelButton,
    RightInfoPanel,
    CancelButton,
  },

  data() {
    return {
      infopanelIsHidden: false,
      publicPath: process.env.BASE_URL,
    };
  },

  mounted() {
    if (localStorage.infopanelIsHidden) {
      this.infopanelIsHidden = localStorage.infopanelIsHidden;
    }
  },
  methods: {

     getBanner1: function () {return process.env.VUE_APP_INFO_BANNER_URL_1 ? {img: process.env.VUE_APP_INFO_BANNER_URL_1, link: process.env.VUE_APP_INFO_BANNER_LINK_1} : null;},
     getBanner2: function () {return process.env.VUE_APP_INFO_BANNER_URL_2 ? {img: process.env.VUE_APP_INFO_BANNER_URL_2, link: process.env.VUE_APP_INFO_BANNER_LINK_2} : null;},
     getBanner3: function () {return process.env.VUE_APP_INFO_BANNER_URL_3 ? {img: process.env.VUE_APP_INFO_BANNER_URL_3, link: process.env.VUE_APP_INFO_BANNER_LINK_3} : null;},
     getBanner4: function () {return process.env.VUE_APP_INFO_BANNER_URL_4 ? {img: process.env.VUE_APP_INFO_BANNER_URL_4, link: process.env.VUE_APP_INFO_BANNER_LINK_4} : null;},
  },
  watch: {
    infopanelIsHidden(newInfopanelIsHidden) {
      localStorage.infopanelIsHidden = newInfopanelIsHidden;
    },
  },
};
</script>

<style scoped>
.static-element-header.nested {
  margin: 10px 0px 0px 0px;
}

.footer-block {
  color: var(--cancel-grey);
  font-size: small;
  border-radius: 10px 10px 0 0;
}

@media (min-width: 950px) {
  .workspace-grid {
    display: grid;
    grid-template-columns: auto 340px;
  }
}

.cancButton {
  float: right;
}

.static-element-header.light {
  color: var(--cancel-grey);
  background: var(--neutral);
}

.static-element-header.grad {
  background: var(--gradient);
}

.static-element-header {
  /* min-height: 25px; */
  padding: 3px 10px;
}

.static-element {
  padding: 5px 10px;
}

.labelButton {
  /* width: 50%; */
  height: 30px;
  margin: 10px auto 50px 10px;
  /* background: var(--gradient); */
}
</style>
